(function () {
  if (window.twrdFreeShipping) { window.twrdFreeShipping.apply(); return; }

  /* Currencies whose everyday amounts are large: round to 10, or 50 above 500. */
  var COARSE = ['DKK', 'SEK', 'NOK', 'ISK', 'HUF', 'UAH', 'JPY', 'CZK', 'RSD'];
  /* Currencies whose everyday amounts are small: round to 5. */
  var FINE = ['EUR', 'USD', 'GBP', 'CHF', 'BAM', 'PLN', 'RON', 'BGN'];

  function activeCurrency() {
    var c = window.Shopify && window.Shopify.currency;
    return (c && c.active) || null;
  }

  function rate() {
    var c = window.Shopify && window.Shopify.currency;
    var r = c && parseFloat(c.rate);
    return (r && isFinite(r) && r > 0) ? r : 1;
  }

  /* Round UP to a friendly step. Rounding up never promises free shipping
     below the real threshold. */
  function roundUp(units, currency) {
    var step;
    if (COARSE.indexOf(currency) !== -1) {
      step = units >= 500 ? 50 : 10;
    } else if (FINE.indexOf(currency) !== -1) {
      step = 5;
    } else {
      step = units >= 200 ? 10 : 5;
    }
    return Math.ceil(units / step) * step;
  }

  function format(units) {
    return window.twrdFormatMoney(Math.round(Number(units) * 100));
  }

  /* Blød afrunding til omregnede beloeb (vouchers). Fri-fragt-taersklen skal
     rundes OP; en voucher maa ikke overdrives, saa her rundes til naermeste. */
  function roundSoft(units) {
    var step = units < 100 ? 1 : (units < 1000 ? 5 : 10);
    return Math.round(units / step) * step;
  }

  function convertSoft(unitsInShopCurrency) {
    return roundSoft(Number(unitsInShopCurrency) * rate());
  }

  /* Convert an amount expressed in the shop currency to the active one. */
  function convert(unitsInShopCurrency) {
    var cur = activeCurrency();
    var converted = Number(unitsInShopCurrency) * rate();
    return cur ? roundUp(converted, cur) : Math.round(converted);
  }

  var lastUnits = null;
  var lastText = null;

  /**
   * THE resolver. Pure: everything it needs is an argument, so it can be run
   * in a test straight out of this file.
   *
   * Precedence, in this order and no other:
   *   0. an international-zone threshold in the SHOP currency (inputs.zoneShop:
   *      AU, CA, JP, MX, NZ) -> an override for the active currency, exact, or
   *      else the shop-currency amount, converted ONCE with Shopify's own rate
   *      and rounded upwards (whole units). It beats the market, because those
   *      countries sit in a market whose value is -1. No exchange rate lives in
   *      the theme: the only rate used is Shopify.currency.rate.
   *   1. market threshold below zero -> the promise is off in this market.
   *   2. a positive market threshold -> used unchanged, it is already in the
   *      presentment currency.
   *   3. an explicit override for the active currency -> used unchanged.
   *   4. the active currency IS the shop currency -> the base, unchanged.
   *   5. any other currency -> the base, converted ONCE, rounded upwards.
   *
   * @param {object} inputs  see 'twrd-fs-inputs'
   * @param {string|null} cur active presentment currency
   * @param {number} rateValue Shopify.currency.rate
   * @returns an object: enabled (boolean), currency (string or null),
   *          thresholdUnits (number), thresholdCents (integer cart units).
   *          Liquid reads a double brace as an output tag, so this comment
   *          states the shape in words instead of in JSDoc braces.
   */
  function twrdResolveFreeShipping(inputs, cur, rateValue) {
    var inp = inputs || {};
    var off = { enabled: false, currency: cur || null, thresholdUnits: 0, thresholdCents: 0 };
    var base = Number(inp.base);
    if (!isFinite(base) || base < 0) base = 0;
    var market = (typeof inp.market === 'number' && isFinite(inp.market)) ? inp.market : null;

    var zoneShop = Number(inp.zoneShop);
    if (isFinite(zoneShop) && zoneShop > 0) {
      var zr = Number(rateValue);
      if (!isFinite(zr) || zr <= 0) zr = 1;
      var zOverrides = {};
      try { zOverrides = JSON.parse(inp.overridesRaw || '{}') || {}; } catch (e) { zOverrides = {}; }
      var zHit = (cur && Object.prototype.hasOwnProperty.call(zOverrides, cur))
        ? Number(zOverrides[cur]) : NaN;
      var zUnits;
      if (isFinite(zHit) && zHit > 0) zUnits = zHit;
      else if (!cur || cur === inp.shopCurrency) zUnits = zoneShop;
      else {
        /* Whole units (10 for the coarse currencies), always upwards. Not the
           5-step of roundUp(): the zone amount is already a tight upper bound,
           and a 5-step would push a normal two-item cart under the line. */
        var zStep = COARSE.indexOf(cur) !== -1 ? 10 : 1;
        zUnits = Math.ceil(Math.round(zoneShop * zr * 100) / 100 / zStep) * zStep;
      }
      return { enabled: true, currency: cur || null, thresholdUnits: zUnits, thresholdCents: Math.round(zUnits * 100) };
    }

    if (market !== null && market < 0) return off;

    var units;
    if (market !== null && market > 0) {
      units = market;
    } else {
      if (!(base > 0)) return off;
      var overrides = {};
      try { overrides = JSON.parse(inp.overridesRaw || '{}') || {}; } catch (e) { overrides = {}; }
      var hit = (cur && Object.prototype.hasOwnProperty.call(overrides, cur))
        ? Number(overrides[cur]) : NaN;
      if (isFinite(hit) && hit > 0) {
        units = hit;
      } else if (!cur || cur === inp.shopCurrency) {
        units = base;
      } else {
        var r = Number(rateValue);
        if (!isFinite(r) || r <= 0) r = 1;
        units = roundUp(base * r, cur);
      }
    }

    var cents = Math.round(units * 100);
    if (!(cents > 0)) return off;
    return {
      enabled: true,
      currency: cur || null,
      thresholdUnits: units,
      thresholdCents: cents
    };
  }

  /** The live threshold for this page. Never cached: the currency can change. */
  function resolveNow() {
    return twrdResolveFreeShipping(window.__TWRD_FS_INPUTS, activeCurrency(), rate());
  }

  /* Generisk: alle beloeb angivet i shop-valuta, fx reward-vouchers.
     Konverteres kun naar den aktive valuta ikke er shop-valutaen, og faar
     da et tilde, fordi tallet er en omregning og ikke en fast pris. */
  function applyConverted() {
    var nodes = document.querySelectorAll('.twrd-conv-amount[data-twrd-conv-units]');
    var cur = activeCurrency();
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var baseCurrency = el.getAttribute('data-twrd-conv-base-currency');
      if (!cur || cur === baseCurrency) { el.removeAttribute('data-twrd-fs-unconverted'); continue; }
      var units = Number(el.getAttribute('data-twrd-conv-units'));
      if (!isFinite(units)) continue;
      el.textContent = '\u2248 ' + format(convertSoft(units));
      el.removeAttribute('data-twrd-fs-unconverted');
    }
  }

  function apply() {
    applyConverted();
    var nodes = document.querySelectorAll('.twrd-fs-amount');
    if (!nodes.length) return;
    var res = resolveNow();
    /* Loeftet er slukket i dette marked. Kalderen skjuler selv saetningen. */
    if (!res.enabled) return;
    var units = res.thresholdUnits;
    var text = format(units);
    lastUnits = units;
    lastText = text;
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== text) nodes[i].textContent = text;
      nodes[i].removeAttribute('data-twrd-fs-unconverted');
    }
    document.dispatchEvent(new CustomEvent('twrd:free-shipping-ready', {
      detail: { units: units, text: text, currency: activeCurrency() }
    }));
  }

  window.twrdFreeShipping = {
    resolve: resolveNow,
    apply: apply,
    applyConverted: applyConverted,
    convert: convert,
    convertSoft: convertSoft,
    format: format,
    amount: function () { return lastText; },
    amountUnits: function () { return lastUnits; },
    rate: rate,
    currency: activeCurrency
  };

  /* Plain name for code outside the theme (the chat widget). Same function. */
  window.TWRD_FREE_SHIPPING = resolveNow;

  apply();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  }
})();
